import { useAuthBearerFetch } from "matsuri-hooks"
import { SubContractActDocument } from "@/model/subContractActDocment"
import { m2mCleaning_cleanerV4 } from "@/endpoints/m2m-cleaning.cleaner-v4"

export const useSubContractActDocument = (
    token: string,
    approvalRequestId: string
) => {
    return useAuthBearerFetch<SubContractActDocument>(
        token,
        m2mCleaning_cleanerV4.getSubContractDocumentByApprovalRequestId({
            approvalRequestId
        })
    )
}
